import { ODataSelect } from "../../../../Providers.Api/ODataQuery";
import { DateHelper } from "../../../../Common/DateHelper";

export class Announcement extends ODataSelect
{
    public Notification_Id = 0;
    public Notification_Title = '';
    public Notification_Priority = 0;
    public Notification_Record_Id = '';
    public Notification_Message = '';
    public Notification_Short_Message = '';
    public Notification_Reminders =  "";
    public Notification_Type = 0;
    public Notification_Status = '';
    public Notification_User_Email = '';
    public Notification_Sent = 0;
    public Notification_Target = 0;
    public Notification_Device = null;
    public CreatedBy = '';
    public Classification = '';
    public Subclassification = '';
    public Available_From = DateHelper.null();
    public Expiry_Date = DateHelper.null();
    public Has_Image = 0;
    public ImageURI = '';
    public ActionURI = '';
    public Node_Id = 0;

    public init(response: any, nodeId: number): Announcement
    {
        super.init(response, nodeId);
        this.Available_From = DateHelper.fromIsoByNode(response.Available_From, nodeId);
        this.Expiry_Date = DateHelper.fromIsoByNode(response.Expiry_Date, nodeId);
        return this;
    }
}

export interface IAnnouncementUpdate
{
    Notification_Id: number;
    Notification_Title: string;
    Notification_Priority: number;
    Notification_Record_Id: string;
    Notification_Message: string;
    Notification_Short_Message: string;
    Notification_Reminders: string;
    Notification_Type: number;
    Notification_Status: string;
    Notification_User_Email: string;
    Notification_Sent: number;
    Notification_Target: number;
    Notification_Device: string[];
    Classification: string;
    Subclassification: string;
    Available_From: string;
    Expiry_Date: string;
    ImageURI: string;
    ActionURI: string;
}